import { useId } from "react";
import { cn } from "@/lib/cn";
import { FieldFrame, fieldStateClasses, fieldSurface } from "./field";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  containerClassName?: string;
}

export function Textarea({
  label,
  hint,
  error,
  required,
  id,
  rows = 4,
  className,
  containerClassName,
  "aria-describedby": ariaDescribedBy,
  ...props
}: TextareaProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const hasError = Boolean(error);
  const errorId = `${inputId}-error`;
  const describedBy =
    [ariaDescribedBy, hasError ? errorId : undefined]
      .filter(Boolean)
      .join(" ") || undefined;

  return (
    <FieldFrame
      label={label}
      hint={hint}
      error={error}
      errorId={errorId}
      required={required}
      htmlFor={inputId}
      className={containerClassName}
    >
      <textarea
        id={inputId}
        rows={rows}
        required={required}
        aria-invalid={hasError || undefined}
        aria-describedby={describedBy}
        className={cn(
          fieldSurface,
          fieldStateClasses(hasError),
          "resize-y py-3 leading-relaxed",
          className,
        )}
        {...props}
      />
    </FieldFrame>
  );
}
